import React from 'react';
import { getWillShowNav4 } from '@atlassian/jira-navigation-apps-sidebar-nav4-rollout-core/src/common/utils/get-will-show-nav4/index.tsx';
import TypeSelector from '../common/type-selector/view.tsx';
import image from './assets/link.svg';
import messages from './messages.tsx';

type Props = {
	onAdd: () => void;
};

export default function LinkSelector(props: Props) {
	const { onAdd } = props;
	return (
		<TypeSelector
			title={getWillShowNav4() ? messages.titleLink : messages.title}
			description={messages.description}
			imageUrl={image}
			onAdd={onAdd}
		/>
	);
}
